export default __webpack_public_path__ + "static/copenhagen-7148111de2d18214233fb3f830c0fb8a.jpg";